import { render, staticRenderFns } from "./update-shipment-status.vue?vue&type=template&id=893951c4&scoped=true"
import script from "./update-shipment-status.vue?vue&type=script&lang=js"
export * from "./update-shipment-status.vue?vue&type=script&lang=js"
import style0 from "./update-shipment-status.vue?vue&type=style&index=0&id=893951c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893951c4",
  null
  
)

export default component.exports